import React, { useEffect, useState } from 'react';
import Editor from "@monaco-editor/react";
import Axios from 'axios';

import * as Antd from 'antd';
import * as AntdIcons from '@ant-design/icons';

export const LogEditor = (props) => {

    const [data, setData] = useState('');

    const fetchData = async () => {
        try {
            let response = await Axios.get(`${process.env.REACT_APP_API_BASE_URI}/api/logs`);
            setData(response.data);
        } catch (err) {
            console.log(err);
        }
    }

    const removeLogFile = async () => {
        try {
            await Axios.delete(`${process.env.REACT_APP_API_BASE_URI}/api/logs`);
            await fetchData();            
        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <>
            <Antd.Space
                style={{
                    marginBottom: 10,
                    float: 'right',
                }}
            >
                <Antd.Button 
                    icon={<AntdIcons.ReloadOutlined />}
                    title="Reload"
                    onClick={() => fetchData()}
                />
                <Antd.Button 
                    icon={<AntdIcons.DeleteOutlined />}
                    title="Remove"
                    onClick={() => removeLogFile()}
                />
            </Antd.Space>
            <Editor
                height="80vh"
                options={{
                    fontSize: 12
                }}
                value={data}
                {...props}
            />
        </>
    )
}